export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9832.ec6fbaf7.jpg";